import request from "../utils/request";
export function getAiRoleMemoryReviewList(params) {
    const queryString = Object.keys(params)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
        .join('&');
    return request({
        url: `/memory/list?${queryString}`,
        method: "get"
    });
}

export function updateAiRoleMemoryReviewStatus(params) {
    return request({
        url: `/memory/updateStatus`,
        method: "post",
        data: params
    });
}
